import { api } from "../api";

/**
 * Informa se o cliente selecionado pelo dev usa o link do portal da transparência.
 * /transparency-portal/link/available?customerId={customerId}
 */
const findTransparencyPortalLinkAvailable = async (token: string, customerId: number) => {
    return api.get<{ available: boolean }>("/transparency-portal/link/available", {
        params: { customerId },
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default findTransparencyPortalLinkAvailable;
